export default __webpack_public_path__ + "static/media/ic_pin_worker_2.029915eb.svg";